<script lang="ts">
    export let item
</script>

<div class="slide">
    <div class="image">
        <picture>
            <source media="(min-width: 768px)" srcset="" />
            <source srcset="" />
            <img src="{item.image}" alt="{item.title || ''}" />
        </picture>
    </div>
    <div class="text">
        <div class="container">
            <div class="text_inner animated">
                {#if item.title}
                    <div class="headline">{item.title}</div>
                {/if}
                {#if item.button_text && item.button_link}
                    <a href="{item.button_link}" class="btn"
                        >{item.button_text}</a
                    >
                {/if}
            </div>
        </div>
    </div>
</div>

<style lang="less">
    @import "../../css/base.less";
    .slide {
        position: absolute;
        @media (max-width: 500px) {
            position: relative;
        }
        top: 0px;
        bottom: 0;
        width: 100%;
        .image {
            height: 100%;
            width: 100%;
            line-height: 0;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .text {
            position: absolute;
            @media (max-width: 500px) {
                position: relative;
                background: #fff;
            }
            top: 0px;
            left: 0px;
            right: 0px;
            bottom: 0px;
            font-size: 2em;
            color: white;
            font-weight: bold;
            width: 100%;
            text-align: center;
            // background: rgba(0, 0, 0, 0.4);
            .flex();
            align-items: center;
            justify-content: flex-end;
            flex-direction: column;
            @media (max-width: 768px) {
                padding: 0px 40px;
            }
            @media (max-width: 500px) {
                padding: 0px 0px;
            }
            .btn {
                padding: 8px 15px;
            }
            .container {
                width: 100%;
                max-width: 100%;
                padding: 0px;
                flex-grow: 1;
                .flex();
            }
            .text_inner {
                padding: 30px;
                .flex();
                height: auto;
                justify-content: flex-end;
                flex-direction: column;
                align-items: flex-start;
                line-height: 1;
                @media (max-width: 500px) {
                    padding: 20px;
                }
                .headline {
                    font-size: 1.5rem;
                    font-weight: 400;
                    margin-bottom: 20px;
                    padding: 15px;
                    background: #fff;
                    text-align: left;
                    color: @textcolor;
                    @media (max-width: 830px) {
                        font-size: 3.8vw;
                        line-height: 1.2;
                        margin-bottom: 10px;
                    }
                    @media (max-width: 500px) {
                        font-size: 1rem;
                        line-height: 1.2;
                        padding: 0px;
                        margin-bottom: 20px;
                    }
                }
            }
        }
    }
</style>
